import { where } from "firebase/firestore";
import { Collection, WhereField } from '../../shared/constants';
import { getAllDocs, getAllDocsByParkId, getAllDocsByQueries, getDocById } from './collectionBaseWorker';

export const getFormasPagamentos = async ({ estacionamentoId }) => {
    return await getAllDocsByParkId({ collection: Collection.FORMAS_PAGAMENTOS, estacionamentoId: estacionamentoId })
}

export const getFormasPagamentosById = async ({ id }) => {
    return await getDocById({ collection: Collection.FORMAS_PAGAMENTOS, id: id })
}

export const getFormasPagamentosAtivas = async ({ estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.FORMAS_PAGAMENTOS,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.STATUS, "==", "Ativo")
        ]
    })
}

export const getFormasPagamentosAtivasSemTags = async ({ estacionamentoId }) => {
    const result = await getFormasPagamentosAtivas({ estacionamentoId: estacionamentoId })
    return result.filter(e => (e.tipo !== "taggy" && e.tipo !== "veloe" && e.tipo !== "conectcar" && e.tipo !== "semparar"))
}

export const getAllPaymentMethodByType = async ({ estacionamentoId, type }) => {
    return await getAllDocsByQueries({
        collection: Collection.FORMAS_PAGAMENTOS,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.TIPO, "==", type)
        ]
    })
}

export const getAllFormasPagamentos = async () => {
    return await getAllDocs({ collection: Collection.FORMAS_PAGAMENTOS })
}